// extracted by mini-css-extract-plugin
export default {"container":"CarInformation_container__UGvq+","carIcon":"CarInformation_carIcon__9x2pd"};